import React from 'react'
import { connect } from 'react-redux'
import { Trans } from 'react-i18next'
import i18next from 'i18next'
import hash from 'object-hash'
import { Button, Modal, Form } from 'react-bootstrap'
import ResponsiveTable from 'src/components/system_wide/responsive_table'
import SearchButton from 'src/components/system_wide/search_button'
import RadiolistFilter from 'src/components/system_wide/radiolist_filter'
import BrandImagePreview from 'src/components/system_wide/brand_image_preview'
import IconButton from 'src/components/system_wide/icon_button'
import { getConstants } from 'src/lib/constants'
import axios from 'src/lib/axios'
import { error } from 'src/components/system_wide/notification'
import DocumentPreview from './document_preview'

const { t } = i18next

const mstp = state => {
  let { id: logged_user_id } = state.userInfo
  return { logged_user_id }
}

const styles = {
  add_modal: {
    minHeight: '55vh',
  },
  add_table: {
    /* border-bottom: solid 0.15rem var(--bs-primary); */
    boxShadow: 'none',
  },
}
class SelectBrandModal extends React.Component {
  static defaultProps = {
    user_id: null,
    selected: [],
    required: false,
    disabled: false,
    className: '',
    style: {},
    multiSelection: true,
    readonly: false,
    excludeBrands: [],

    onChange: () => {},
  }

  state = {
    show: false,
    all_brands: [],
    selected_brands: [],
    selected_filter: 'all', //all, selected, unselected
    search_filter: '',
  }

  tableRef = null
  previewModalRef = null
  filter_by_selected = []
  constructor(props) {
    super(props)

    this.tableRef = React.createRef()
    this.previewModalRef = React.createRef()
    let { filter_by_selected } = getConstants(t)
    this.state.selected_brands = props.selected.map(b => b.toString())
    Object.keys(filter_by_selected).forEach(key => {
      this.filter_by_selected.push({ id: key, name: filter_by_selected[key] })
    })
  }

  getAllBrands = async user_id => {
    try {
      let response = await axios({ url: `/api/brands/all`, method: 'GET', params: { user_id } })
      let brands =
        this.props.readonly === false
          ? response.data.brands
          : response.data.brands.filter(b => this.state.selected_brands.includes(b.id.toString()))

      brands = brands.filter(b => !this.props.excludeBrands.includes(b.id))

      this.setState({ all_brands: brands })
    } catch (err) {
      error(t('store.brands.get_brands_error', 'Impossibile recuperare lista brand'))
      this.setState({ all_brands: [] })
    }
  }

  componentDidUpdate(prevProps) {
    if (hash(prevProps.selected) !== hash(this.props.selected)) {
      this.setState({
        selected_brands: this.props.selected.map(b => b.toString()),
      })
    }
  }
  async componentDidMount() {
    let user_id = this.props.user_id || this.props.logged_user_id
    await this.getAllBrands(user_id)
  }

  componentWillUnmount() {
    this.setState({ all_brands: [] })
  }

  show = async () => {
    let user_id = this.props.user_id || this.props.logged_user_id
    await this.getAllBrands(user_id)
    this.setState({ show: true, selected_brands: this.props.selected.map(b => b.toString()), selected_filter: 'all' })
  }

  hide = () => {
    this.setState({ show: false })
  }

  toggleBrands = ({ target: { value } }) => {
    let { selected_brands, all_brands } = this.state
    const { multiSelection } = this.props
    let brand = all_brands.find(b => b.id === parseInt(value))
    if (brand.enabled === false) return
    if (multiSelection) {
      if (selected_brands.includes(value)) {
        this.setState({ selected_brands: selected_brands.filter(e => e !== value) })
      } else {
        this.setState({ selected_brands: [...selected_brands, value] })
      }
    } else {
      this.setState({ selected_brands: [value] })
    }
  }

  toggleAllBrands = () => {
    let { search_filter, selected_filter, selected_brands } = this.state
    let brands = this.searchFilterBrands(search_filter, selected_filter)

    let enabledBrands = brands.filter(b => b.enabled)

    let all_selected = enabledBrands.every(b => selected_brands.includes(b.id.toString()))

    let current_brands = []
    if (all_selected) {
      current_brands = selected_brands.filter(su => !enabledBrands.find(b => b.id === parseInt(su)))
    } else {
      current_brands = new Set([...selected_brands, ...enabledBrands.map(e => e.id.toString())])
    }

    // Aggiorna lo stato con i marchi selezionati
    this.setState({ selected_brands: [...current_brands] })
  }

  selectBrandCheckbox = ({ rowData }) => {
    let { selected_brands } = this.state
    if (this.props.readonly === true) return
    return (
      <Form.Check
        type={this.props.multiSelection === true ? 'checkbox' : 'radio'}
        className="py-1"
        value={rowData.id}
        checked={selected_brands.includes(rowData.id.toString())}
        onChange={this.toggleBrands}
        disabled={rowData.enabled === false && !selected_brands.includes(rowData.id.toString())}
      />
    )
  }

  brandImageRenderer = ({ rowData }) => {
    let { brand_img, name, id } = rowData
    let url = brand_img ? `/api/brands/${id}/image` : ''

    return (
      <BrandImagePreview
        src={url}
        style={{ width: '3rem', height: '3rem' }}
        onClick={() =>
          this.previewModalRef.current.showModal({
            url,
            mime_type: 'image/*',
            title: name,
          })
        }
      />
    )
  }

  columns = [
    {
      name: 'selection',
      title: this.props.multiSelection === true && (
        <IconButton
          icon="far fa-check-square me-0"
          tooltip={t('components.users.brand_modal.select_all_tooltip', 'Seleziona/Deseleziona Tutti')}
          onClick={this.toggleAllBrands}
        />
      ),
      className: 'd-lg-block text-center',
      style: { width: '5%', minWidth: '3rem' },
      data: this.selectBrandCheckbox,
    },
    {
      title: '',
      className: 'd-sm-block text-center',
      style: { minWidth: '3.5rem' },
      data: this.brandImageRenderer,
    },
    {
      title: t('components.users.brand_modal.name', 'Nome'),
      className: 'd-block flex-fill',
      style: { width: '30%' },
      data: 'name',
    },
    {
      title: t('components.users.brand_modal.business_name', 'Ragione sociale'),
      className: 'd-none d-sm-block flex-fill',
      style: { width: '30%' },
      data: 'business_name',
    },
  ]

  getColumns = () => {
    if (this.props.readonly === true) {
      this.columns = this.columns.filter(c => c.name !== 'selection')
    }
    return this.columns
  }

  onChangeFilter = name => values => {
    this.setState({ [name]: values }, () => {
      this.tableRef.current.refreshData()
    })
  }

  onChangeSearchFilter = filter => this.setState({ search_filter: filter.replace(/[.*?^$]+/, '') })

  searchFilterBrands = (search_filter, selected_filter) => {
    let { selected } = this.props
    let { selected_brands, all_brands } = this.state
    let brands = all_brands

    let regexp = new RegExp(`.*${search_filter ? search_filter : ' '}.*`, 'i')
    brands = brands.filter(e => {
      let name = `${e.name} ${e.business_name}`
      return regexp.test(name)
    })

    selected = selected.map(id => id.toString())
    brands = brands.filter(b => b.enabled === true || selected.includes(b.id.toString()))
    if (selected_filter === 'selected') {
      brands = brands.filter(u => selected_brands.includes(u.id.toString()))
    }

    if (selected_filter === 'unselected') {
      brands = brands.filter(u => !selected_brands.includes(u.id.toString()))
    }

    return brands
  }

  handleConfirm = () => {
    let { selected_brands } = this.state
    this.props.onChange(selected_brands)
    this.hide()
  }

  onRowClick = rowData => {
    if (rowData.enabled === false) return
    // if (rowData.enabled === false && !this.state.selected_brands.includes(rowData.id.toString())) {
    //   return
    // }
    const event = { target: { value: rowData.id.toString() } }
    this.toggleBrands(event)
  }

  render() {
    let { show, search_filter, selected_filter } = this.state
    let { required, disabled, multiSelection, selected, readonly } = this.props
    let brands = this.searchFilterBrands(search_filter, selected_filter)
    return (
      <>
        <div className={`${this.props.className}`} style={this.props.style}>
          <Form.Label>
            <Trans i18nKey="components.users.brands">Brand</Trans>
            {required === true && <span> *</span>}
          </Form.Label>
          <div className="mt-1 d-flex flex-row align-items-center mb-3">
            <div className="d-flex flex-row align-items-center">
              <>
                {multiSelection === true && (
                  <div className="text-muted">
                    <b>{this.props.selected.length || 0}</b>{' '}
                    <Trans i18nKey="components.users.brands_selected">selezionati</Trans>
                  </div>
                )}
                {multiSelection === false && (
                  <>
                    {(selected.length || 0) === 0 && (
                      <div className="text-muted">
                        <em>{t('components.users.no_selected_label', 'Nessun brand selezionato')}</em>
                      </div>
                    )}
                    {(selected.length || 0) > 0 && (
                      <>
                        <b>{this.state.all_brands.find(b => b.id.toString() === selected[0].toString())?.name || ''}</b>
                        {readonly === false && (
                          <span className="ms-1">
                            <Trans i18nKey="components.users.brand_selected">selezionato</Trans>
                          </span>
                        )}
                      </>
                    )}
                  </>
                )}
              </>

              <Button className="ms-2" onClick={this.show} disabled={disabled}>
                <i className="fas fa-plus fa-fw text-start me-0"></i>
                {selected.length > 0 && readonly === false && (
                  <Trans i18nKey="components.users.edit_brand">Modifica</Trans>
                )}
                {selected.length === 0 && readonly === false && (
                  <Trans i18nKey="components.users.add_brand">Aggiungi</Trans>
                )}
                {readonly === true && <Trans i18nKey="components.users.view_brand">Visualizza</Trans>}
              </Button>
            </div>
          </div>
        </div>

        <Modal backdrop="static" centered contentClassName={styles.add_modal} show={show} onHide={this.hide} size="xl">
          <Modal.Header>
            <Modal.Title>
              <Trans i18nKey="components.users.brand_modal.title">Brand</Trans>
            </Modal.Title>
          </Modal.Header>
          <Modal.Body className="d-flex flex-column" style={{ height: '60vh' }}>
            <div className="d-flex flex-row mb-3">
              {readonly === false && (
                <div className="flex-fill">
                  <RadiolistFilter
                    label={t('filter_selected', 'Selezionati')}
                    items={this.filter_by_selected}
                    value={selected_filter}
                    onChangeFilter={this.onChangeFilter('selected_filter')}
                  />
                </div>
              )}
              <div className="flex-fill">
                <SearchButton
                  className={readonly === false ? 'float-end' : 'float-sm-end'}
                  value={this.state.search_filter}
                  onChange={this.onChangeSearchFilter}
                />
              </div>
            </div>
            <ResponsiveTable
              ref={this.tableRef}
              className={`flex-fill ${styles.add_table}`}
              data={brands}
              totalRecords={brands.length}
              columns={this.getColumns()}
              rowClasses={rowData => (rowData.enabled ? '' : `text-muted`)}
              onRowClick={readonly === false && this.onRowClick}
              hideStatusBar={false}
            />
          </Modal.Body>
          <Modal.Footer>
            <Button onClick={this.hide} variant="secondary">
              <Trans i18nKey="buttons.cancel">Annulla</Trans>
            </Button>
            {readonly === false && (
              <Button onClick={this.handleConfirm} variant="primary">
                <Trans i18nKey="buttons.confirm">Conferma</Trans>
              </Button>
            )}
          </Modal.Footer>
        </Modal>

        <DocumentPreview ref={this.previewModalRef} />
      </>
    )
  }
}

export default connect(mstp, null, null, { forwardRef: true })(SelectBrandModal)
